import { render, staticRenderFns } from "./request-details.vue?vue&type=template&id=3a42d8ef&"
import script from "./request-details.vue?vue&type=script&lang=js&"
export * from "./request-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports